module.exports = __webpack_public_path__ + "static/img/搜索暂无icon@2x@2x.f113c95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/搜索暂无icon@2x@2x.png
// module id = xInG
// module chunks = 192